import { useDraggable } from '@dnd-kit/core';
import { ReactNode } from 'react';
import { DragAndDropId } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/tabs/Securities/SecurityRanking/securityRankingTypes.ts';

export const DraggableSecurityCard = ({
	id,
	draggedFromId,
	children,
	disabled = false,
	highlighted = false,
	onNodeRef,
}: {
	id: string;
	draggedFromId: DragAndDropId | string;
	children: ReactNode;
	disabled?: boolean;
	highlighted?: boolean;
	/** Exposes the card's DOM node so the parent can scroll it into view on a deep-link. */
	onNodeRef?: (element: HTMLElement | null) => void;
}) => {
	const { attributes, listeners, setNodeRef, isDragging } = useDraggable({
		id,
		data: { draggedFromId },
		disabled,
	});

	return (
		<div
			ref={(element) => {
				setNodeRef(element);
				onNodeRef?.(element);
			}}
			{...listeners}
			{...attributes}
			className={highlighted ? 'security-card-highlight' : undefined}
			style={{
				opacity: isDragging ? 0.5 : 1,
			}}
		>
			{children}
		</div>
	);
};
